"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesStopLossProfitProcessor = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const lodash_1 = require("lodash");
/** 合约网格处理止盈止损逻辑 */
var GridV4FuturesStopLossProfitProcessor;
(function (GridV4FuturesStopLossProfitProcessor) {
    /**
     * 是否是空值, 包括 undefined, null, ""
     */
    const isBlankValue = (val) => (0, lodash_1.isNil)(val) || ((0, lodash_1.isString)(val) && val.trim() === "");
    function safeFormatNumToStr(n, defaultStr) {
        if (n === undefined || n === null || n === "") {
            return defaultStr !== null && defaultStr !== void 0 ? defaultStr : undefined;
        }
        return new trade_utils_lib_1.SafeDecimal(n).toFixed();
    }
    // 跟单校验止损的值
    function followOrderValidStopLoss({ order, currentPrice, $st, }) {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const illegalTips = [];
        const stopLossConfig = {};
        if (innerOrder.loss_stop_type) {
            // 按价格止损
            if (innerOrder.loss_stop_type === TradeAPILib_1.GridStopType.price || innerOrder.loss_stop_type === TradeAPILib_1.GridStopType.price_limit) {
                if (innerOrder.trendForUI === TradeAPILib_1.GridFuturesTrend.long && !isBlankValue(innerOrder.stop_for_ui)) {
                    if (new trade_utils_lib_1.SafeDecimal(innerOrder.stop_for_ui).lt(new trade_utils_lib_1.SafeDecimal(currentPrice))) {
                        stopLossConfig.loss_stop_type = innerOrder.loss_stop_type;
                        stopLossConfig.stop_for_ui = safeFormatNumToStr(innerOrder.stop_for_ui, "");
                        if (!(0, lodash_1.isNil)(innerOrder.lossStopDelay)) {
                            stopLossConfig.lossStopDelay = innerOrder.lossStopDelay.toString();
                        }
                    }
                    else {
                        illegalTips.push($st("open_order_advance_err_tips_stop_loss_low", { price: currentPrice }));
                    }
                }
                if (innerOrder.trendForUI === TradeAPILib_1.GridFuturesTrend.short && !isBlankValue(innerOrder.stop_for_ui)) {
                    if (new trade_utils_lib_1.SafeDecimal(innerOrder.stop_for_ui).gt(new trade_utils_lib_1.SafeDecimal(currentPrice))) {
                        stopLossConfig.loss_stop_type = innerOrder.loss_stop_type;
                        stopLossConfig.stop_for_ui = safeFormatNumToStr(innerOrder.stop_for_ui, "");
                        if (!(0, lodash_1.isNil)(innerOrder.lossStopDelay)) {
                            stopLossConfig.lossStopDelay = innerOrder.lossStopDelay.toString();
                        }
                    }
                    else {
                        illegalTips.push($st("open_order_advance_err_tips_stop_loss_high", { price: currentPrice }));
                    }
                }
                if (innerOrder.trendForUI === TradeAPILib_1.GridFuturesTrend.no_trend) {
                    stopLossConfig.loss_stop_type = innerOrder.loss_stop_type;
                    const isRangePriceRight = new trade_utils_lib_1.SafeDecimal(innerOrder.lowForUI).lt(new trade_utils_lib_1.SafeDecimal(currentPrice)) &&
                        new trade_utils_lib_1.SafeDecimal(innerOrder.highForUI).gt(new trade_utils_lib_1.SafeDecimal(currentPrice));
                    const stopLossHasValue = (innerOrder.stop_for_ui && !isBlankValue(innerOrder.stop_for_ui)) ||
                        (innerOrder.stopHighForUI && !isBlankValue(innerOrder.stopHighForUI));
                    if (!isRangePriceRight && stopLossHasValue) {
                        illegalTips.push($st("open_order_advance_err_tips_stop_loss_no_trend"));
                    }
                    else {
                        if (innerOrder.stop_for_ui && !isBlankValue(innerOrder.stop_for_ui)) {
                            stopLossConfig.stop_for_ui = safeFormatNumToStr(innerOrder.stop_for_ui, "");
                        }
                        if (innerOrder.stopHighForUI && !isBlankValue(innerOrder.stopHighForUI)) {
                            stopLossConfig.stopHighForUI = safeFormatNumToStr(innerOrder.stopHighForUI, "");
                        }
                    }
                }
                // 按限价止损
                if (innerOrder.loss_stop_type === TradeAPILib_1.GridStopType.price_limit) {
                    stopLossConfig.loss_stop_limit_price_for_ui = safeFormatNumToStr(innerOrder.loss_stop_limit_price_for_ui, "");
                    if (innerOrder.trend === TradeAPILib_1.GridFuturesTrend.no_trend) {
                        stopLossConfig.loss_stop_limit_high_price_for_ui = safeFormatNumToStr(innerOrder.loss_stop_limit_high_price_for_ui, "");
                    }
                }
            }
            else {
                if (!isBlankValue(innerOrder.stop_for_ui)) {
                    if (new trade_utils_lib_1.SafeDecimal(innerOrder.stop_for_ui).lt(0)) {
                        stopLossConfig.loss_stop_type = innerOrder.loss_stop_type;
                        stopLossConfig.stop_for_ui = safeFormatNumToStr(innerOrder.stop_for_ui, "");
                        if (!(0, lodash_1.isNil)(innerOrder.lossStopDelay)) {
                            stopLossConfig.lossStopDelay = innerOrder.lossStopDelay.toString();
                        }
                    }
                    else {
                        illegalTips.push(innerOrder.loss_stop_type === TradeAPILib_1.GridStopType.profit_amount
                            ? $st("open_order_advance_err_tips_stop_loss_no_trend_amount")
                            : $st("open_order_advance_err_tips_stop_loss_no_trend_ratio"));
                    }
                }
            }
        }
        return {
            stopLossConfig,
            illegalTips,
        };
    }
    GridV4FuturesStopLossProfitProcessor.followOrderValidStopLoss = followOrderValidStopLoss;
    // 跟单校验止盈
    function followOrderValidStopProfit({ order, currentPrice, $st, }) {
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(order);
        const illegalTips = [];
        const stopProfitConfig = {};
        if (innerOrder.profit_stop_type) {
            if (innerOrder.profit_stop_type === TradeAPILib_1.GridStopType.price_limit || innerOrder.profit_stop_type === TradeAPILib_1.GridStopType.price) {
                if (innerOrder.trendForUI === TradeAPILib_1.GridFuturesTrend.long && !isBlankValue(innerOrder.trailing_for_ui)) {
                    if (new trade_utils_lib_1.SafeDecimal(innerOrder.trailing_for_ui).gt(new trade_utils_lib_1.SafeDecimal(currentPrice))) {
                        stopProfitConfig.profit_stop_type = innerOrder.profit_stop_type;
                        stopProfitConfig.trailing_for_ui = safeFormatNumToStr(innerOrder.trailing_for_ui, "");
                    }
                    else {
                        illegalTips.push($st("open_order_advance_err_tips_stop_profit_high", { price: currentPrice }));
                    }
                }
                if (innerOrder.trendForUI === TradeAPILib_1.GridFuturesTrend.short && !isBlankValue(innerOrder.trailing_for_ui)) {
                    if (new trade_utils_lib_1.SafeDecimal(innerOrder.trailing_for_ui).lt(new trade_utils_lib_1.SafeDecimal(currentPrice))) {
                        stopProfitConfig.profit_stop_type = innerOrder.profit_stop_type;
                        stopProfitConfig.trailing_for_ui = safeFormatNumToStr(innerOrder.trailing_for_ui, "");
                    }
                    else {
                        illegalTips.push($st("open_order_advance_err_tips_stop_profit_low", { price: currentPrice }));
                    }
                }
                if (innerOrder.trendForUI === TradeAPILib_1.GridFuturesTrend.no_trend && !isBlankValue(innerOrder.trailing_for_ui)) {
                    stopProfitConfig.profit_stop_type = innerOrder.profit_stop_type;
                    stopProfitConfig.trailing_for_ui = safeFormatNumToStr(innerOrder.trailing_for_ui, "");
                }
            }
            else {
                stopProfitConfig.profit_stop_type = innerOrder.profit_stop_type;
                stopProfitConfig.trailing_for_ui = safeFormatNumToStr(innerOrder.trailing_for_ui, "");
            }
            if (!(0, lodash_1.isNil)(innerOrder.profitStopDelay)) {
                stopProfitConfig.profitStopDelay = innerOrder.profitStopDelay.toString();
            }
            if (innerOrder.profit_stop_type === TradeAPILib_1.GridStopType.price_limit) {
                stopProfitConfig.profit_stop_limit_price_for_ui = safeFormatNumToStr(innerOrder.profit_stop_limit_price_for_ui, "");
            }
        }
        return { stopProfitConfig, illegalTips };
    }
    GridV4FuturesStopLossProfitProcessor.followOrderValidStopProfit = followOrderValidStopProfit;
})(GridV4FuturesStopLossProfitProcessor || (exports.GridV4FuturesStopLossProfitProcessor = GridV4FuturesStopLossProfitProcessor = {}));
